module.exports = __webpack_public_path__ + "dingbeauty-build/img/2@2.42b537c9.jpg";